module.exports = __webpack_public_path__ + "static/img/Sample Document - Document your expenses.51fa776f.svg";